import * as React from 'react';
import {Button, CircularProgress, Grid} from "@mui/material";
import {ArrowBackIos, OpenInNew} from "@mui/icons-material";
import Body from "../global/Body";
import reducer from "../../store/request";
import withReducer from "../../store/withReducer";
import {memo, useEffect, useRef, useState} from "react";
import {selectRequestState, setStep} from "../../store/request/stateSlice";
import {useDispatch, useSelector} from "react-redux";
import Typography from "@mui/material/Typography";
import DetailService from "./components/DetailService";
import Api from "../../inc/Api";
import Alert from "../../inc/Alert";

function Step5Prepaid() {

    const {item} = useSelector(selectRequestState);
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(true);
    const [link, setLink] = useState(null);
    const pollRef = useRef(null);

    useEffect(() => {
        if (!item.id) {
            Alert.error('No se pudo obtener el ID del servicio. Vuelve al paso anterior.');
            return;
        }
        loadLink();
        window.addEventListener('focus', checkPaid);
        pollRef.current = setInterval(checkPaid, 4000);
        return () => {
            window.removeEventListener('focus', checkPaid);
            if (pollRef.current) clearInterval(pollRef.current);
        };
    }, [item.id]);

    function loadLink() {
        setLoading(true);
        Api.post('/client/widgets/createLinkPrepaid', {id_service: item.id}, rsp => {
            setLoading(false);
            if (rsp.ok) {
                setLink(rsp.link);
                window.open(rsp.link, '_blank')?.focus();
            } else {
                Alert.error(rsp.msg);
            }
        }, false);
    }

    function checkPaid() {
        Api.get('/client/widgets/checkPaid', {id_service: item.id}, rsp => {
            if (rsp.ok) {
                if (pollRef.current) clearInterval(pollRef.current);
                dispatch(setStep('6_paid'));
            }
        }, false);
    }

    function goPay() {
        if (link) {
            window.open(link, '_blank')?.focus();
        }
    }

    return (
        <Body title="Realizar pago">

            <Grid container spacing={3}>

                <Grid xs={12} md={6} item display={{xs: 'none', md: 'block'}}>

                    <DetailService/>

                </Grid>

                <Grid xs={12} md={6} item>

                    <Grid container spacing={3}>

                        <Grid xs={12} item>

                            <Typography color="white" variant="h6">
                                Tu reserva fue creada. Para confirmarla, completa el pago en la nueva pestaña que se abrirá.
                            </Typography>

                            <Typography color="white" variant="body2" mt={2}>
                                Una vez aprobado el pago, esta pantalla avanzará automáticamente.
                            </Typography>

                        </Grid>

                        <Grid xs={6} item>

                            <Button
                                variant="contained"
                                startIcon={<ArrowBackIos/>}
                                onClick={() => dispatch(setStep('4'))}
                                color="secondary"
                                disabled={loading}
                                fullWidth>
                                Volver
                            </Button>

                        </Grid>

                        <Grid xs={6} item>

                            <Button
                                variant="contained"
                                endIcon={!loading && <OpenInNew/>}
                                onClick={goPay}
                                disabled={loading || !link}
                                fullWidth>

                                {loading ? <CircularProgress color="inherit" size="24px"/> : 'Ir a pagar'}

                            </Button>

                        </Grid>

                    </Grid>

                </Grid>

            </Grid>

        </Body>
    );
}

export default withReducer('request', reducer)(memo(Step5Prepaid));
